import React from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import SEO from 'utils/seo';
import Projects from 'data/containers/projects';

import { ProjectTransition } from './transitions';
import './style.css';

const Home = props => {
    const locationKey = props.location.pathname.split('/')[2] || '/';
    const path = props.match.url;
    return (
        <div className="Home">
            <SEO schema="Website" path={path} hasLoaded={true} />
            <TransitionGroup className="Home__projects" component="div">
                <ProjectTransition key={locationKey} appear>
                    <Switch location={props.location}>
                        <Route exact path={`/`} component={Projects} />
                        <Route
                            exact
                            path={`/filter/:id`}
                            component={Projects}
                        />
                    </Switch>
                </ProjectTransition>
            </TransitionGroup>
        </div>
    );
};

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/templates/home/index.js